<style>
    tr.selectable:hover {
        @apply bg-blue-100;
    }
    tr.selectable {
        @apply cursor-pointer;
    }
</style>

<script>
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    import api from '../api';
    import { comoMoneda, MES_POR_NUMERO } from '../utils';
    import Nota from '../components/nota.svelte';
    import { traerProductos } from './productos/_productos.svelte';
    import { TIPOS } from './notas/_store.svelte';

    let ventas_por_mes = [];

    let seleccionada = null;
    let cancelando = false;
    let params = {};
    $: params, (seleccionada = null), traerVentas();
    $: seleccionada, (cancelando = false);

    async function traerVentas() {
        const response = await api.get('ventas/', { params });
        ventas_por_mes = [...response.data];
    }

    $: ventas_por_mes, (cancelando = false);

    async function cancelarVenta(id) {
        await api.patch(`ventas/${id}/cancelar/`);
        traerVentas();
        traerProductos();
    }
</script>

<div class="flex justify-evenly">
    <div>
        <table class="sticky border">
            <thead>
                <tr>
                    <td colspan="4">
                        <div class="group">
                            {#each Object.values(TIPOS) as tipo_}
                                <button
                                    class:active="{params.tipo === tipo_}"
                                    on:click="{() => (params = { tipo: tipo_ })}"
                                    class="capitalize"
                                >
                                    {tipo_}
                                </button>
                            {/each}
                            <button
                                class:active="{params.con_regalo}"
                                on:click="{() => (params = { con_regalo: true })}"
                            >
                                Con Regalo
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="text-right">Numero</th>
                    <th class="">Cliente</th>
                    <th class="text-right">Fecha</th>
                    <th class="text-right">Total</th>
                </tr>
            </thead>
            <tbody>
                {#each ventas_por_mes as { año, mes, total_por_mes, ventas }}
                    <tr class="sticky font-bold bg-white" style="top: 2.6rem;">
                        <td colspan="4">{MES_POR_NUMERO[mes]} del {año}</td>
                    </tr>
                    {#each ventas as { num_venta, cliente, fecha, total, id }, i}
                        <tr
                            transition:fade
                            on:click="{() => (seleccionada = { ...ventas[i] })}"
                            class:bg-blue-200="{seleccionada && id === seleccionada.id}"
                            class="selectable"
                        >
                            <td class="text-right">{num_venta}</td>
                            <td class="">{cliente}</td>
                            <td class="text-right">{fecha}</td>
                            <td class="text-right">{comoMoneda(total)}</td>
                        </tr>
                    {/each}
                    <tr class="font-bold">
                        <td colspan="3">Total</td>
                        <td class="text-right">{comoMoneda(total_por_mes)}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <div>
        <div class="sticky top-0">
            <div class="pt-4">
                {#if seleccionada}
                    <div
                        in:fade
                        id="{`venta-${seleccionada.num_venta}`}"
                        class="relative flex items-start"
                    >
                        {#if cancelando}
                            <div
                                class="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full bg-white"
                                transition:fade
                            >
                                <div>
                                    ¿Segura que quieres cancelar la venta
                                    <span class="font-bold">
                                        {seleccionada.num_venta}
                                    </span>
                                    ?
                                </div>
                                <div class="flex mt-4">
                                    <button
                                        class="mr-8"
                                        on:click="{() => (cancelando = false)}"
                                    >
                                        Regresar
                                    </button>
                                    <button
                                        variant="error"
                                        on:click="{() => cancelarVenta(seleccionada.id)}"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        {/if}
                        <Nota {...seleccionada} />
                        <i
                            class="ml-4 rounded cursor-pointer material-icons"
                            variant="error"
                            on:click="{() => (cancelando = true)}"
                        >
                            clear
                        </i>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>
